import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=21f921b6&scoped=true&"
import script from "./Secret.vue?vue&type=script&lang=js&"
export * from "./Secret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f921b6",
  null
  
)

export default component.exports